export default __webpack_public_path__ + "static/media/metamask-fox.b6b09bd4.svg";